module.exports = __webpack_public_path__ + "media/images/emblems/Oberried_am_Brienzersee-coat_of_arms-5d8810a034ecf8d9c674567bb1a46c34.svg";